import React from "react";

import LogoWithShadow from "./../LogoWithShadow";
import DialogueBox from "./DialogueBox";
import DialogueSlider from "./DialogueSlider";
import SectionHeader from "./SectionHeader";
import AppDialogueBox from "./AppDialogueBox";
import ChatBox from "./ChatBox";
import ThreeThings from "./ThreeThings";
import SlackThread from "./SlackThread";
import NewsArticles from "./NewsArticles";
// import ButtonLink from "./../ButtonLink";
import PageSection from "../PageSection";
import PageFooter from "./PageFooter";
import footerLinks from "../../footerLinks";
import AppContext from "../AppContext";
import Header from "../Header";

const SERVER_URL = process.env.REACT_APP_API_URL;
const authUrl = `${SERVER_URL}/auth/slack`;

class LandingPage extends React.Component {
    render() {
        return (
            <AppContext.Consumer>
                {context => {
                    const { authenticated } = context.state;

                    return (
                        <div className="landing-page">
                            <PageSection sectionName="intro">
                                <Header
                                    hideLogo={true}
                                    authenticated={authenticated}
                                />
                                <LogoWithShadow />
                                <p className="section--intro__tagline">
                                    a small gratitude practice for teams
                                </p>
                            </PageSection>
                            <PageSection sectionName="three-things">
                                <SectionHeader
                                    introText="Be grateful together"
                                    titleText="3things is just 3 things"
                                    textAlignment="center"
                                />
                                <ThreeThings />
                            </PageSection>
                            <PageSection sectionName="blurbs">
                                <SectionHeader
                                    introText="Raised at Playground Inc."
                                    titleText="A weekly ritual that brought our team closer together"
                                    textAlignment="center"
                                />
                                <DialogueSlider>
                                    <DialogueBox
                                        bodyText="I like waiting for 3things to start, so the people I’ve tagged can read my responses!"
                                        avatarName="terence"
                                        index={1}
                                    />
                                    <DialogueBox
                                        bodyText="I like that we all get to spend our Fridays saying nice things to each other"
                                        avatarName="maja"
                                        index={2}
                                    />
                                    <DialogueBox
                                        bodyText="I like that it’s just three things, reading them always gives me that warm and fuzzy feeling."
                                        avatarName="asis"
                                        index={3}
                                    />
                                </DialogueSlider>
                            </PageSection>
                            <PageSection sectionName="app-dialogue">
                                <SectionHeader
                                    introText="Now over to you"
                                    titleText="We want the same for you and your team"
                                    textAlignment="center"
                                />
                                <AppDialogueBox
                                    isPinned
                                    bodyText="Hey ready to share your 3 things this week?"
                                    actionBtn="Let's do it!"
                                    bodyHasBorder
                                    hasShadow
                                />
                            </PageSection>
                            <PageSection sectionName="thoughts">
                                <SectionHeader
                                    introText="Encourage your team to open up"
                                    titleText="Give everyone a chance to share their world"
                                    textAlignment="center"
                                />
                                <DialogueSlider>
                                    <DialogueBox
                                        bodyText="I hope people don’t think I’m weird just because I’m shy"
                                        avatarName="dave"
                                        thoughtBubble
                                    />
                                    <DialogueBox
                                        bodyText="I wonder if anyone else is struggling to learn Framer"
                                        avatarName="ken"
                                        thoughtBubble
                                    />
                                    <DialogueBox
                                        bodyText="I wonder if anyone else spends so much on coffee!"
                                        avatarName="ryan"
                                        thoughtBubble
                                    />
                                </DialogueSlider>
                            </PageSection>
                            <PageSection sectionName="reflect">
                                <SectionHeader
                                    introText="We’re always so busy"
                                    titleText="Take a moment to stop and reflect"
                                />
                                <div className="section__content--reflect-image">
                                    <img
                                        className="reflect-image"
                                        src={require("../../imgs/reflect.png")}
                                        alt=""
                                    />
                                    <img
                                        className="reflect-image--mobile"
                                        src={require("../../imgs/reflect_mobile.png")}
                                        alt=""
                                    />
                                </div>
                            </PageSection>
                            <PageSection sectionName="chatbox">
                                <SectionHeader
                                    introText="Sharing is caring"
                                    titleText="Celebrate your week together"
                                />
                                <ChatBox channelName="Everyone" />
                            </PageSection>
                            <PageSection sectionName="thread">
                                <SectionHeader
                                    introText="Bring everyone closer together"
                                    titleText="Spark conversations and show some love"
                                    textAlignment="center"
                                />
                                <SlackThread />
                            </PageSection>
                            <PageSection sectionName="news">
                                <SectionHeader
                                    introText="The signs are everywhere"
                                    titleText="Gratefulness = Happiness"
                                    subText="(not the other way around)"
                                    textAlignment="center"
                                />
                                <NewsArticles />
                            </PageSection>
                            <PageFooter
                                authUrl={authUrl}
                                links={footerLinks}
                                authenticated={authenticated}
                            />
                        </div>
                    );
                }}
            </AppContext.Consumer>
        );
    }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/components/landingPage/LandingPage.jsx